import CorePrice from './CorePrice';
import CorePriceContainer from './CorePrice.container';

export default CorePriceContainer(CorePrice);
